import { Page, Pagebar, PagebarTitle } from '@monorepo/base/src/components/page/page';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useEffect, useState } from 'react';
import { PrimaryButton } from '@monorepo/base/src/components/buttons/buttons';
import { CreativeGroupForm } from '../../../modules/components/forms/creative-group/creative-group.form';
import { observer } from 'mobx-react';
import { generatePath /*, useLocation*/, useParams } from 'react-router-dom';
import { Disable } from '@monorepo/base/src/components/disable/disable';
import { BottomBar, BottomBarActions } from '@monorepo/base/src/components/bottom-bar/bottom-bar';
import styles from './create-creative-group.module.scss';
import { DispatchLogsTypes, useLogs } from '@monorepo/controlled/src/hooks/use-logs';
import routes from '../../../modules/routes/index.routes';
import { ErrorMsg } from '../../../modules/components/error-msg/error-msg';
import { SiderSlider } from '@monorepo/base/src/components/sider-slider/sider-slider';
import { BetweenPagesStateProps } from '@monorepo/tools/src/lib/interfaces/global';
import { route } from '@monorepo/tools/src/lib/types/url';
import { IAdminxStore } from '../../../modules/stores';
import { DataAttribute } from '@monorepo/tools/src/lib/models/data-attr.model';
import { useNavigateParams } from '@monorepo/tools/src/lib/hooks/tools/use-navigate-params';

interface ICreateCreativeGroups {
	parentRoute?: route;
}

export const CreateCreativeGroups = observer((props: ICreateCreativeGroups) => {
	const { parentRoute } = props;
	const { creativeGroupsStore } = useStores<IAdminxStore>();
	const [isFormClicked, setFormClicked] = useState<boolean>(false);

	const { advertiserId } = useParams();

	const { dispatchLog } = useLogs();
	const navigate = useNavigateParams();
	// const location = useLocation();

	// useEffect(() => {
	// 	creativeGroupsStore.resetCrud();
	// }, [location]);

	const creativeGroupCrudStore = creativeGroupsStore.getCrud();
	const name = creativeGroupCrudStore.getData().getDesign();
	const formStore = creativeGroupCrudStore.getFormStore();
	const isValidForm = formStore.getIsValid();
	const isLoading = creativeGroupCrudStore.getIsLoading();
	const isSuccess = creativeGroupCrudStore.getIsSuccess();
	const error = creativeGroupCrudStore.getHttpError();

	useEffect(() => {
		if (!isValidForm && isFormClicked) {
			dispatchLog({
				msg: 'Please complete all mandatory fields',
				type: DispatchLogsTypes.Error,
			});
		}
	}, [isFormClicked]);

	useEffect(() => {
		if (isSuccess) {
			navigate(generatePath(parentRoute || routes.creativeGroups.index(), { advertiserId }), {
				state: { isBlockRequest: false } as BetweenPagesStateProps,
			});
			dispatchLog({
				msg: `Creative Group ${name} was successfully added`,
				type: DispatchLogsTypes.Success,
			});
			creativeGroupCrudStore.setIsSuccess(false);
		}
	}, [isSuccess]);

	const onCreateCreativeGroup = () => {
		setFormClicked(true);
		creativeGroupsStore.getCrud().create();
	};

	const onCloseSiderSlider = () => {
		navigate(generatePath(parentRoute || routes.creativeGroups.index(), { advertiserId }), {
			state: { isBlockRequest: true } as BetweenPagesStateProps,
		});
	};

	return (
		<SiderSlider onClose={onCloseSiderSlider} isOpen={true}>
			<Disable is={isLoading}>
				<Page>
					<Pagebar>
						<PagebarTitle unstyled={true}>
							<div className={styles.title}>Create Creative Group</div>
						</PagebarTitle>
					</Pagebar>
					<CreativeGroupForm />
				</Page>
				<BottomBar>
					{error ? <ErrorMsg error={error} /> : null}
					<BottomBarActions>
						<PrimaryButton
							onClick={() => onCreateCreativeGroup()}
							debugProps={{ dataAttrs: [new DataAttribute('id', 'create_creative_groups_button')] }}
							isRotateIcon={isLoading}
							icon={isLoading ? 'loading-01' : 'send-03'}>
							Create
						</PrimaryButton>
					</BottomBarActions>
				</BottomBar>
			</Disable>
		</SiderSlider>
	);
});
